import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedPdfsConverter extends CmsConverterService<PanelRowRelatedPdfsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      links: formData.st_panel_row_related_pdf_links_list ?? defaultFSCatalog
    }
  }
}

export const PANEL_ROW_RELATED_PDFS_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedPdfsData>>('PanelRowRelatedPdfsConverter')

export interface PanelRowRelatedPdfsData extends ConvertedComponentData {
  links: FsCatalog;
}
